export const ROUTE_NAME = { references: 'references' };

export enum ECustomReferenceRowAction {
  info = 'info',
  add = 'add',
  edit = 'edit',
  delete = 'delete',
}
